import { render, staticRenderFns } from "./LogotypesUpload.vue?vue&type=template&id=5328fb6e&"
import script from "./LogotypesUpload.vue?vue&type=script&lang=js&"
export * from "./LogotypesUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports